/*
 * AnnouncementMessage Messages
 *
 * This contains all the text for the AnnouncementMessage component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.AnnouncementMessage';

export default defineMessages({
  beforeXmas: {
    id: `${scope}.specificTimeMessage`,
    defaultMessage:
      "Please note: Our Support Team won't be available on Christmas Day, December 25th. Surveys submitted for approval on the 25th will be reviewed the next day. Happy Holidays!",
  },
  beforeNewYears: {
    id: `${scope}.specificTimeMessage`,
    defaultMessage:
      "Please note: Our Support Team won't be available on New Year's Day, January 1st. Surveys submitted for approval on the 1st will be reviewed the next day. Happy New Year!",
  },
  specificTimeMessage: {
    id: `${scope}.specificTimeMessage`,
    defaultMessage:
      'Our Support Team will not be available today and thus the survey approval process will take place when the team is available again. Happy holidays!',
  },
  maintenanceMessage: {
    id: `${scope}.maintenanceMessage`,
    defaultMessage:
      'Sorry, we are down for scheduled maintenance. In the meantime, you may not be able to access some services. Thank you for your patience.',
  },
});
